import { useEffect, useState } from "react";
import { io } from "socket.io-client";

const SOCKET_URL = "https://v3api.digidoc.co.in/";

let socketInstance = null;

const useSocket = () => {
  const [socket, setSocket] = useState(socketInstance);

  useEffect(() => {
    if (!socketInstance) {
      const token = localStorage.getItem("doctorToken");

      socketInstance = io(SOCKET_URL, {
        auth: {
          token,
        },
        transports: ["websocket", "polling"],
        autoConnect: true,
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
      });

      socketInstance.on("connect", () => {
        console.log("✅ Socket Connected:", socketInstance.id);
      });

      socketInstance.on("disconnect", (reason) => {
        console.log("❌ Socket Disconnected:", reason);
      });

      socketInstance.on("connect_error", (err) => {
        console.error("❌ Socket Error:", err.message);
      });

      socketInstance.on("reconnect", (attempt) => {
        console.log(`🔄 Socket Reconnected (${attempt})`);
      });

      socketInstance.on("reconnect_attempt", (attempt) => {
        console.log(`🔄 Reconnect Attempt ${attempt}`);
      });

      socketInstance.on("reconnect_error", (err) => {
        console.error("❌ Reconnect Error:", err.message);
      });

      socketInstance.on("reconnect_failed", () => {
        console.error("❌ Reconnect Failed");
      });
    }

    setSocket(socketInstance);

    return () => {
      // Don't disconnect here.
      // This keeps one shared socket instance alive across the app.
    };
  }, []);

  return socket;
};

export default useSocket;